export default "__VITE_ASSET__BVGwOEUq__"